import BaseStore from '@src/utils/store/base-store';

class MainStore extends BaseStore {
  use() {
    super.use();
  }
}

export default MainStore;
